import {hasAnyContent} from "../utils/object.js";

export async function validateHandler(config, data, options = {
    editMode: false,
    fieldChangedFlags: {},
    customValidator: (data, error) => {},
}) {
    const { editMode, fieldChangedFlags, customValidator } = options;

    // validate by config!
    const error = validateByConfig(config, data, editMode, fieldChangedFlags);

    // custom validator!
    if (customValidator) {
        await customValidator(data, error);
    }

    // has error?
    const hasError = hasAnyContent(error);


    return { error, hasError };
}

function validateByConfig(config, data, editMode, fieldChangedFlags) {
    let error = {};

    for (let key in config) {
        if (config.hasOwnProperty(key)) {
            const rules = config[key];
            const value = data[key];

            // editMode 인데 필드값 변경이 없었으면 스킵.
            if (editMode && !fieldChangedFlags[key]) {
                continue;
            }

            if (rules.required) {
                // check value is array
                if (Array.isArray(value)) {
                    if (!value || value.length === 0) {
                        error[key] = '필수 입력입니다.';
                    }
                } else {
                    if (!value) {
                        error[key] = '필수 입력입니다.';
                    }
                }
            }
            if (!error[key] && rules.minLength && value.length < rules.minLength) {
                error[key] = `최소 ${rules.minLength}글자 이상 입력해주세요.`;
            }
            if (!error[key] && rules.maxLength && value.length > rules.maxLength) {
                error[key] = `최대 ${rules.maxLength}글자 이하로 입력해주세요.`;
            }
            if (!error[key] && rules.email && !validateEmail(value)) {
                error[key] = '이메일 형식이 아닙니다.';
            }
            if (!error[key] && rules.phone && !validatePhone(value)) {
                error[key] = '전화번호 형식이 아닙니다.';
            }
            if (!error[key] && rules.password && !validatePassword(value)) {
                error[key] = '비밀번호 형식이 아닙니다.';
            }
            if (!error[key] && rules.english && !validateEnglish(value)) {
                error[key] = '영어만 입력해주세요.';
            }
            if (!error[key] && rules.number && !validateNumber(value)) {
                error[key] = '숫자만 입력해주세요.';
            }
        }
    }

    return error;
}

function validateEmail(email) {
    const re = /\S+@\S+\.\S+/;
    return re.test(email);
}

function validatePhone(phone) {
    const re = /^01(?:0|1|[6-9])(?:\d{3}|\d{4})\d{4}$/;
    return re.test(phone);
}


function validatePassword(password) {
    const re = /^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=-])(?=.*[0-9]).{8,16}$/;
    return re.test(password);
}


function validateEnglish(value) {
    // const hangulPattern = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/g
    const re = /^[^\u3131-\u318E\uAC00-\uD7A3]*$/;
    return re.test(value);
}


function validateNumber(value) {
    const re = /^[0-9]*$/;
    return re.test(String(value || ""));
}